/* global G */

/**
 * Stores the cart API configuration on the adapter state and dispatches `G.CART, G.CREATE`
 * to fetch (or create) the user's active cart.
 *
 * @param {Gaia.Web.Application} app  the Platform Web Application
 * @returns {AttachmentEventListener}  an AttachmentEventListener
 */
const fn = app => ({ detail = {} }) => {
  const eventBus = app[G.ADAPTER][G.EVENTS]
  const adapter = app[G.ADAPTER][G.CART]

  const { [G.DATA]: { [G.API]: api } = {} } = detail

  adapter[G.STATE][G.API] = api

  // Dispatching G.CREATE to fetch the cart
  eventBus.dispatch(eventBus.type(G.CART, G.CREATE))
}

export default fn
